import axios from 'axios'
import store from '@/store'
import router from "@/router";
import {toast} from "../class/Notification";
import {findObjectIndex} from "../class/Converter";
import {queryBuilder, filters} from '../class/QueryFilter'

let filtersCopy = JSON.parse(JSON.stringify(filters))

const stringToJson = (json) => {
    return JSON.parse(json)
}

const reshapeFormFill = (form) => {
    let formData = new FormData();

    Object.entries(form).forEach((value, index) => {
        formData.append(`form_fill_items[${index}][form_item_id]`, value[0]);
        formData.append(`form_fill_items[${index}][answer]`, value[1]);
    });

    return formData;
}


export const formQuestion = (form, questionsId) => {
    let formQuestion = stringToJson(form.form_questions)['form']
    let result = null

    formQuestion.forEach(item => {
        if (item.id == questionsId) {
            result = item
        }
    })

    return result
}

export const formAnswer = (form, questionsId, answer) => {
    let question = formQuestion(form, questionsId);
    let result = null

    if (question == null) {
        return result
    }

    if (['textarea', 'selctbox', 'image', 'range', 'text', 'radiobox'].indexOf(question['type']) > -1) {
        return {label: answer.answer, type: question['type']}
    }

    let questionOptions = question['options'];

    questionOptions.forEach(item => {
        if (item.id == answer.answer) {
            result = item
        }
    })

    return result
}

const reshapeForm = (form) => {
    let baseForm = Object.assign({}, form)
    baseForm.form_questions = JSON.stringify(baseForm.form_questions)
    return baseForm
}

export default {
    namespaced: true,
    state: {
        forms: [],
        trash: [],
        pagination: [],
        ...filtersCopy,
    },
    mutations: {
        setForms(state, forms) {
            state.forms = forms
        },
        setPagination(state, meta) {
            state.pagination = meta
        },
        setFilters(state, filter) {
            const keys = Object.keys(state.filters)
            for (let i in keys) {
                state.filters[filter.key] = filter.value;
                return
            }
        },
    },
    actions: {
        getForm({commit, state}, form) {
            const query = queryBuilder(state.filters)
            let req = axios.get(`/show-form/${form.form_id}`)
            req.then(res => {
                const data = res.data.data;
            })
                .catch(error => {
                    console.log(error)
                })
            return req
        },
        getFormDashboard({commit, state}, form) {
            const query = queryBuilder(state.filters)
            let req = axios.get(`/form/${form.form_id}`)
            req.then(res => {
                const data = res.data.data;
            })
                .catch(error => {
                    console.log(error)
                })
            return req
        },
        getForms({commit, state}, page = 1) {
            const query = queryBuilder(state.filters)
            let req = axios.get(`/form?page=${page}&${query}`)
            req.then(res => {
                const data = res.data.data;
                commit('setForms', data.data)
                commit('setPagination', data.meta)
            })
                .catch(error => {
                    console.log(error)
                })
            return req
        },
        createForm({commit, state}, form) {
            let req = axios.post(`/form`, reshapeForm(form))
            req.then(res => {
                const data = res.data.data;

            })
                .catch(error => {
                    console.log(error)
                })
            return req
        },
        updateForm({commit, state}, form) {
            let req = axios.put(`/form/${form.id}`, reshapeForm(form))
            req.then(res => {
                const data = res.data.data;

            })
                .catch(error => {
                    console.log(error)
                })
            return req
        },
        removeForm({commit, state}, form) {
            let req = axios.delete(`/form/${form.id}`)
            req.then(res => {
                const data = res.data.data;

            })
                .catch(error => {
                    console.log(error)
                })
            return req
        },
        getFormFills({commit, state}, form) {
            const query = queryBuilder(state.filters)
            let req = axios.get(`/form-fills/${form.form_id}?page=${form.page}`)
            req.then(res => {
                const data = res.data.data;
            })
                .catch(error => {
                    console.log(error)
                })
            return req
        },
        getFormAnswer({commit, state}, form) {
            let req = axios.get(`user/${form.user_id}/form-fill/${form.form_fill_id}`)
            req.then(res => {
                const data = res.data.data;
            })
                .catch(error => {
                    console.log(error)
                })
            return req
        },
        getUserFormFills({commit, state}, form) {
            const query = queryBuilder(state.filters)
            let req = axios.get(`user/${form.user_id}/form-fills?page=${form.page}`)
            req.then(res => {
                const data = res.data.data;
            })
                .catch(error => {
                    console.log(error)
                })
            return req
        },
        storeFormAnswer({commit, state}, form) {
            let req = axios.post(`/form-fill/${form.form_id}`, reshapeFormFill(form.answer))
            req.then(res => {
                const data = res.data.data;
            })
                .catch(error => {
                    console.log(error)
                })
            return req
        },
        paperToAnswer({commit, state}, form) {
            let req = axios.post(`/paper-to-answer/form/${form.get('form_id')}`, form)
            req.then(res => {
                const data = res.data.data;

            })
                .catch(error => {
                    console.log(error)
                })
            return req
        },
        getItemForm({commit, state}, form) {
            let req = axios.post(`/get-item-form`, form)
            req.then(res => {
                const data = res.data.data;
            })
                .catch(error => {
                    console.log(error)
                })
            return req
        },
        connectFormToAnyItem({commit, state}, form) {
            let req = axios.post(`/connect-form-to-any-item`, form)
            req.then(res => {
                const data = res.data.data;
            })
                .catch(error => {
                    console.log(error)
                })
            return req
        },
        formLessons({commit, state}, form) {
            let req = axios.get(`/form-lessons/${form.id}`)
            req.then(res => {
                const data = res.data.data;
            })
                .catch(error => {
                    console.log(error)
                })
            return req
        },
        setDescriptionOfFormFill({commit, state}, form) {
            let req = axios.post(`/description/form-fills/${form.id}`, form)
            req.then(res => {
                const data = res.data.data;
            })
                .catch(error => {
                    console.log(error)
                })
            return req
        }
    },
    getters: {
        getForms: state => state.forms,
        getPagination: state => state.pagination,
        getFilters: (state) => state.filters,
    }
}